import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Round to one decimal and drop the trailing ".0" so e.g. 890.0 → "890",
 * 1.0 → "1", 7.83 → "7.8", 45.0 → "45". Used across stats UI.
 */
export function fmt1(n: number): string {
  const s = n.toFixed(1);
  return s.endsWith(".0") ? s.slice(0, -2) : s;
}
